var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { OGButton } from '@opengear/buttons';
import { useFormContainerContext } from '@/components/layout/forms';
export function SelectFirmwareSelectFile(_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    var watch = useFormContainerContext().watch;
    var selectedFirmware = watch('firmware');
    if (selectedFirmware)
        return null;
    return (_jsx(Box, { children: _jsx(OGButton, __assign({ variant: "secondary", onClick: onClick }, { children: t('pages.firmware_upgrade_new.buttons.select_firmware') })) }));
}
